import { render, staticRenderFns } from "./itemDetail.vue?vue&type=template&id=61c2391e&scoped=true"
import script from "./itemDetail.vue?vue&type=script&lang=js"
export * from "./itemDetail.vue?vue&type=script&lang=js"
import style0 from "./itemDetail.vue?vue&type=style&index=0&id=61c2391e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2391e",
  null
  
)

export default component.exports